<template>

    <div v-if="isVisible" class="modal-overlay modal">
        <div class="modal-content w-75 p-0">

            <div class="modal-header p-3">
                <div>
                    <h5 class="mb-0">Ficha Técnica</h5>
                    <small>{{ aplicacao?.nome }}</small>
                </div>
                <i class="ri-close-line cursor-pointer" @click="closeModal"></i>
            </div>

            <div class="modal-body p-3 overflow-auto" style="max-height: 70vh;">

                <h5>AWS</h5>
                <p class="mb-1">instanceId: <b>{{ aplicacao.instanceId_aws }}</b></p>
                <p class="mb-1">IP: <b>{{ aplicacao.ip }}</b></p>
                <hr>

                <h5>SSH</h5>
                <p class="mb-1">Host: <b>{{ aplicacao.host_ssh }}</b></p>
                <p class="mb-1">Usuário: <b>{{ aplicacao.usuario_ssh }}</b></p>
                <p class="mb-1">Senha: <b>{{ aplicacao.senha_ssh }}</b></p>
                <hr>

                <h5>Banco de dados (MYSQL)</h5>
                <p class="mb-1">Host: <b>{{ aplicacao.host_db }}</b></p>
                <p class="mb-1">Banco: <b>{{ aplicacao.nome_db }}</b></p>
                <p class="mb-1">Usuário: <b>{{ aplicacao.usuario_db }}</b></p>
                <p class="mb-1">Senha: <b>{{ aplicacao.senha_db }}</b></p>
                <hr>

                <h5>FTP</h5>
                <p class="mb-1">Host: <b>{{ aplicacao.host_ftp }}</b></p>
                <p class="mb-1">Usuário: <b>{{ aplicacao.usuario_ftp }}</b></p>
                <p class="mb-1">Senha: <b>{{ aplicacao.senha_ftp }}</b></p>
                <hr>

                <h5>Gerenciador AXION</h5>
                <p class="mb-1">Id: <b>{{ aplicacao.id_aplicacao_gerenciador }}</b></p>

            </div>



        </div>
    </div>

</template>

<script>

import SocketService from '@/services/SocketService';

export default {
    props: {
        isVisible: {
            type: Boolean,
            default: false
        },
        aplicacao: {
            type: Object
        }
    },
    emits: ['close'],
    data() {
        return {}
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
    },
    mounted() {
    },
    beforeUnmount() {
        SocketService.disconnect()
    }
}
</script>